// src/aboutmentor.js
import React from 'react';
import './aboutmentor.css';

import mentor1 from '../assets/akkiraju.png';
import mentor2 from '../assets/rajasekhar.png';
import mentor3 from '../assets/shamini.png';
import mentor4 from '../assets/sajeed.png';

const mentors = [
  {
    image: mentor1,
    title: 'Cyber Security',
    name: 'Akkiraju Hari Kishore',
    subtitle:
      'Ex‑Cisco | SOC Analyst | Threat Hunter | Cybersecurity Mentor at Cisco\n10y Exp | Top Cyber Mentor | Network Security Expert | Blue Team Specialist',
    skills: ['Network Security', 'Ethical Hacking', 'Incident Response', 'Linux Forensics'],
  },
  {
    image: mentor2,
    title: 'Python + AI/ML',
    name: 'Raja Sekhar Thota',
    subtitle:
      'Ex‑Infosys | ML Engineer | Python Developer | AI Coach at Infosys\n8y Exp | AI Mentor | NLP & Vision Expert | Python Core Trainer',
    description:
      'Raghav blends academic clarity with real‑world Python and AI skills — from model building to deployment. His mentoring focuses on hands‑on projects like chatbots, image classification, and automation.',
    skills: ['Python', 'Machine Learning', 'Pandas', 'TensorFlow', 'Flask', 'AI Deployment'],
  },
  {
    image: mentor3,
    title: 'Full Stack Java Development',
    name: 'Shamini',
    subtitle:
      'Ex‑TCS | Java Developer | Backend Lead | Full Stack Mentor at TCS\n11y Exp | Java Spring Expert | Placement‑Oriented Mentor | Project Coach',
    description:
      'Sneha transforms Java learners into full‑stack professionals with strong backend expertise, real‑time project building, and end‑to‑end development from Spring Boot to frontend integration.',
    skills: ['Java', 'Spring Boot', 'Hibernate', 'REST APIs', 'MySQL', 'Maven'],
  },
  {
    image: mentor4,
    title: 'Full Stack Web Development',
    name: 'Mohammad sajeed',
    subtitle:
      'Ex‑Wipro | Frontend Engineer | UI/UX Mentor | MERN Developer at Wipro\n9y Exp | React Pro | Live Project Mentor | Design‑to‑Code Expert',
    description:
      'Arjun teaches students to build beautiful, fully responsive websites using the MERN stack and popular UI frameworks. From wireframes to deployment — all in one place.',
    skills: ['HTML/CSS', 'JavaScript', 'React.js', 'MongoDB', 'Node.js', 'Bootstrap'],
  },
];

export default function Mentorship() {
  // const [selected, setSelected] = useState(null);   // modal state

  return (
    <>
      <div className="mentorship-container">
        <div className="back-arrow" onClick={() => window.history.back()}>← Back</div>
        <div class="d-flex flex-column align-items-center">
          <div className="heading-box">
            Mentorship is a relationship between two individuals where knowledge, skills, and experience are shared.
          </div>
        </div>


        <div className="mentor-grid">
          {mentors.map((m, i) => (
            <div className="mentor-card vertical" key={i}>
              <div class="d-flex flex-row">
                <div className="mentor-image-centered">
                  <img src={m.image} alt={m.name} />
                </div>
                <div> 
                  <h2 className="mentor-title">{m.title}</h2>
                  <div className="mentor-name-chip">{m.name}</div>
                </div>
              </div>

              <div className="mentor-experience">
                <strong>Experience:</strong>
                <p>{m.subtitle}</p>
              </div>

              <div className="mentor-skills">
                <strong>Skills:</strong>
                <div className="skill-tags">
                  {m.skills.map((s, idx) => (
                    <span key={idx} className="skill-tag">{s}</span>
                  ))}
                </div>
              </div>
              <div class="text-center">
              <a
                href="https://calendly.com/robokalam"
                target="_blank"
                rel="noreferrer noopener"
                className="navigation-btn"
              >
                Make Your Career Plan
              </a></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}